import { useQuery } from "@tanstack/react-query";
import { IPaidFeature } from "@evennt-tech/api-v2-core";
import { apiV2 } from "api/firebase";
import { RequestKey } from "api/request-key";

const EMPTY: IPaidFeature[] = [];

export const paidFeaturesQueryKey = [RequestKey.GetAllPaidFeaturesApiV2];

/**
 * The paid-feature catalog (name, priority, price, storage limit). Not
 * show-scoped, so every consumer shares one cached request.
 */
export const usePaidFeatures = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: paidFeaturesQueryKey,
    queryFn: () => apiV2.paidFeature.getAll({}),
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: false,
  });

  return { paidFeatures: data ?? EMPTY, isLoading, error };
};
